import { render } from "./EnergyConsumedDashboard.vue?vue&type=template&id=ddde0da8&scoped=true"
import script from "./EnergyConsumedDashboard.vue?vue&type=script&lang=js"
export * from "./EnergyConsumedDashboard.vue?vue&type=script&lang=js"

import "./EnergyConsumedDashboard.vue?vue&type=style&index=0&id=ddde0da8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddde0da8"]])

export default __exports__